import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserStorageService } from './storage.service';
import { DashboardViewEnum } from '../enum/dashboard-view.enum';

@Injectable({
  providedIn: 'root',
})
export class UserDashboardViewSelectedService {
  private storageKey = 'UserDashboardViewSelected';

  private userDashboardViewSelectedSubject = new BehaviorSubject<
    DashboardViewEnum | undefined
  >(DashboardViewEnum.DashboardViewInternationalCatalogs);
  public userDashboardViewSelectedSubject$ =
    this.userDashboardViewSelectedSubject.asObservable();

  constructor(private browserStorageService: BrowserStorageService) {
    this.userDashboardViewSelectedSubject.next(
      this.getUserDashboardViewSelected()
    );
  }

  getUserDashboardViewSelected(): DashboardViewEnum | undefined {
    const storedDashboardViewSelected = this.browserStorageService.get(
      this.storageKey
    );
    return (
      (storedDashboardViewSelected as DashboardViewEnum) ??
      DashboardViewEnum.DashboardViewInternationalCatalogs
    );
  }

  updateUserDashboardViewSelected(dashboardView: DashboardViewEnum): void {
    this.browserStorageService.set(this.storageKey, dashboardView);
    this.userDashboardViewSelectedSubject.next(dashboardView);
  }
}
